(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('FinalSummaryConfirmController',FinalSummaryConfirmController);

    FinalSummaryConfirmController.$inject = ['$uibModalInstance', 'FinalSummary'];

    function FinalSummaryConfirmController($uibModalInstance,  FinalSummary) {
        var vm = this;

        vm.clear = clear;
        vm.saveData = saveData;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function saveData() {

        	FinalSummary.save({urlItem:'final-summary'},function(result){
        		$uibModalInstance.close(true);
          	},function(error) {
//          		vm.isSaving = false;
    		});
        }
    }
})();
